import React from 'react'

import { ModalInjectedProps, ToastLink } from '@sketch/components'

import { ProjectFragment, useCreateProjectMutation } from '@sketch/gql-types'
import NestedProjectModalContent, {
  FormProps,
} from './NestedProjectModalContent'
import { useToast } from '@sketch/toasts'
import { routes } from '@sketch/modules-common'
import { useEventDispatch } from '@sketch/utils'

interface CreateNestedProjectModalProps extends ModalInjectedProps {
  project: ProjectFragment
  workspaceIdentifier: string
}

export const CreateNestedProjectModal = (
  props: CreateNestedProjectModalProps
) => {
  const { project, workspaceIdentifier, hideModal } = props
  const { showToast } = useToast()
  const dispatchSharesRefresh = useEventDispatch('workspaceShareRefresh')

  const [createProject, { loading }] = useCreateProjectMutation({
    onError: 'show-toast',
    onCompleted: ({ createWorkspaceProject }) => {
      const { name, identifier } = createWorkspaceProject.project

      dispatchSharesRefresh({
        workspaceIdentifier,
        projectIdentifier: project.identifier,
        onlyProjects: true,
      })

      showToast(
        <>
          &quot;
          <ToastLink
            to={routes.WORKSPACE_PROJECT.create({
              workspaceId: workspaceIdentifier,
              projectId: identifier,
            })}
          >
            {name}
          </ToastLink>
          &quot; project created
        </>
      )

      hideModal?.()
    },
  })

  const handleSubmit = (values: FormProps) => {
    createProject({
      variables: {
        parentProjectIdentifier: project.identifier,
        workspaceId: workspaceIdentifier,
        name: values.name,
        description: values.description ?? '',
      },
    })
  }

  return (
    <NestedProjectModalContent
      onSubmit={handleSubmit}
      project={project}
      isLoading={loading}
      hideModal={hideModal}
    />
  )
}

export default CreateNestedProjectModal
